import { useMemo } from 'react';
import { getImpersonationSession, isImpersonationTab } from '../services/impersonationSession';
import { stopImpersonation } from '../services/impersonationService';

/**
 * The read-only impersonation state of this tab. It is fixed for the life of the page: the tab is flagged before React
 * renders, and ending the impersonation reloads into the dealer app.
 */
export const useImpersonation = () => {
    const isImpersonating = isImpersonationTab();
    const session = useMemo(() => (isImpersonating ? getImpersonationSession() : null), [isImpersonating]);

    return { isImpersonating, session, stop: stopImpersonation };
};
